import { isKeyOf } from '@issuemanager/apps/client/utils';
import { IssueClassificationEnum } from '@issuemanager/constants';
import { useTranslation } from 'react-i18next';

type UseLocalizedClassificationReturnType = {
  getClassificationLabel: (value: string | undefined) => string | undefined;
};

export function useLocalizedClassification(): UseLocalizedClassificationReturnType {
  const { t } = useTranslation('common');

  const classificationMap: Record<IssueClassificationEnum, string> = {
    [IssueClassificationEnum.DEFICIENCY]: t('issueClassification.deficiency'),
    [IssueClassificationEnum.RECOMMENDATION]: t(
      'issueClassification.recommendation',
    ),
  };

  return {
    getClassificationLabel: (value: string | undefined): string | undefined => {
      if (!value) return undefined;
      return isKeyOf(value, classificationMap)
        ? classificationMap[value]
        : value;
    },
  };
}
